import http from "@/http";

export async function handleImagemOcr(imagem) {
  const blob = await fetch(imagem).then(res => res.blob());

  const formData = new FormData();
  formData.append("image", new File([blob], "filename.png"));

  const response = await http.post("/api/ocr/analyze", formData);

  return response.data;
}
